module.exports = __webpack_public_path__ + "img/game-icons.0f0c89a2.svg";